import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  Row,
  Col,
  PreviewCard,
  BlockBetween,
} from "../../../components/Component";
import { DropdownToggle, DropdownMenu, UncontrolledDropdown, DropdownItem } from "reactstrap";
import { Link } from "react-router-dom";
import { api } from "../../../utils/api";
import { toast } from "react-toastify";

const appPath = (path) => {
  const p = path.startsWith("/") ? path : `/${path}`;
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}${p}`;
};

const HsePilotagePage = () => {
  const [sm, updateSm] = useState(false);
  const [operational, setOperational] = useState(null);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState("year");
  const loadingRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (loadingRef.current) return;
      loadingRef.current = true;
      setLoading(true);

      try {
        const params = {};
        if (period === "month") {
          params.start_date = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0];
          params.end_date = new Date().toISOString().split("T")[0];
        } else if (period === "year") {
          params.start_date = new Date(new Date().getFullYear(), 0, 1).toISOString().split("T")[0];
          params.end_date = new Date().toISOString().split("T")[0];
        }

        const operationalResponse = await api.getOperationalDashboard(params);
        if (!cancelled && operationalResponse) {
          setOperational(operationalResponse);
        }
      } catch (error) {
        if (!cancelled) {
          if (error.response?.status === 429) {
            toast.error("Trop de requêtes. Veuillez patienter quelques instants.");
          } else {
            toast.error("Erreur lors du chargement du pilotage transversal");
          }
          console.error(error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
        loadingRef.current = false;
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [period]);

  if (loading) {
    return (
      <Content>
        <div className="text-center py-5">Chargement...</div>
      </Content>
    );
  }

  return (
    <React.Fragment>
      <Head title="Pilotage transversal" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Pilotage transversal
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>
                  Agrégat inspections, observations, permis, MOC et incidents — retards workflow et volumes par site
                </p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="more-v"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light">
                          <Icon className="d-none d-sm-inline" name="calender-date"></Icon>
                          <span>{period === "month" ? "Ce mois" : "Cette année"}</span>
                          <Icon className="dd-indc" name="chevron-right"></Icon>
                        </DropdownToggle>
                        <DropdownMenu>
                          <ul className="link-list-opt no-bdr">
                            <li>
                              <DropdownItem
                                href="#p"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  setPeriod("month");
                                }}
                              >
                                Ce mois
                              </DropdownItem>
                            </li>
                            <li>
                              <DropdownItem
                                href="#p"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  setPeriod("year");
                                }}
                              >
                                Cette année
                              </DropdownItem>
                            </li>
                          </ul>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className="g-gs">
            <Col size="12">
              <PreviewCard className="card-full">
                <div className="card-title-group align-start gx-3 mb-3">
                  <div className="card-title">
                    <h6 className="title">Indicateurs multi-modules</h6>
                    <p className="text-soft mb-0">Vue consolidée sur la période sélectionnée</p>
                  </div>
                  <div className="card-tools ms-auto position-relative" style={{ zIndex: 1 }}>
                    <Link
                      to={appPath("/users/audit")}
                      className="btn btn-outline-light btn-sm d-inline-flex align-items-center"
                    >
                      <Icon name="activity" />
                      <span className="ms-1">Journal d&apos;audit</span>
                    </Link>
                    <Link
                      to={appPath("/hse-process")}
                      className="btn btn-outline-light btn-sm d-inline-flex align-items-center ms-1"
                    >
                      <Icon name="grid-alt" />
                      <span className="ms-1">Processus HSE</span>
                    </Link>
                  </div>
                </div>
                {operational ? (
                  <React.Fragment>
                    <Row className="g-gs mb-3">
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount">{operational.observations?.created_in_period ?? 0}</div>
                          <div className="info text-soft">Obs. créées (période)</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount text-warning">{operational.observations?.open ?? 0}</div>
                          <div className="info text-soft">Obs. ouvertes</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount text-danger">{operational.observations?.workflow_overdue ?? 0}</div>
                          <div className="info text-soft">Obs. échéance workflow dépassée</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount">{operational.inspections?.in_period ?? 0}</div>
                          <div className="info text-soft">Inspections (période)</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount">{operational.permits?.active ?? 0}</div>
                          <div className="info text-soft">Permis actifs</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount text-warning">{operational.permits?.expiring_within_7_days ?? 0}</div>
                          <div className="info text-soft">Permis expirent &lt; 7 j.</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount">{operational.moc?.open_pipeline ?? 0}</div>
                          <div className="info text-soft">MOC en pipeline</div>
                        </div>
                      </Col>
                      <Col sm="6" lg="3">
                        <div className="nk-ecwg-data">
                          <div className="amount text-danger">{operational.incidents?.open ?? 0}</div>
                          <div className="info text-soft">Incidents ouverts</div>
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th>Site</th>
                            <th className="text-end">Obs. (période)</th>
                            <th className="text-end">Insp.</th>
                            <th className="text-end">Incidents</th>
                            <th className="text-end">Permis actifs</th>
                            <th className="text-end">MOC pipe.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(operational.by_site || []).length ? (
                            operational.by_site.map((row) => (
                              <tr key={row.site_id}>
                                <td>{row.site_name || "—"}</td>
                                <td className="text-end">{row.observations_created ?? 0}</td>
                                <td className="text-end">{row.inspections ?? 0}</td>
                                <td className="text-end">{row.incidents ?? 0}</td>
                                <td className="text-end">{row.permits_active ?? 0}</td>
                                <td className="text-end">{row.moc_pipeline ?? 0}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6} className="text-center text-soft py-3">
                                Aucun site ou aucune donnée pour la période.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                ) : (
                  <p className="text-soft small mb-0">Aucune donnée disponible.</p>
                )}
              </PreviewCard>
            </Col>
          </Row>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default HsePilotagePage;
